module.exports = __webpack_public_path__ + "static/media/Air Quality.3e00592b.png";